import PlayPreview from '@/images/PlayPreview.svg';
import theme from '@/theme';
import styled from '@emotion/styled';
import { DEFAULT_SCENE_DURATION_IN_MS } from '../../../constants';
import './scene-popup.css';

const NO_DURATION_CONTENT = '--';

const missingScriptTooltipIcon = `url("data:image/svg+xml;utf8,<svg width='14' height='14' viewBox='0.5 -4 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'> <g id='Linear / Messages, Coversation /  Chat Line'> <path id='Vector' d='M7.63372 12.476L8.01021 12.6988L8.01021 12.6988L7.63372 12.476ZM7.94994 11.9417L7.57345 11.7189L7.57345 11.7189L7.94994 11.9417ZM6.04971 11.9417L5.67322 12.1646L5.67322 12.1646L6.04971 11.9417ZM6.36593 12.476L6.74242 12.2531L6.74242 12.2531L6.36593 12.476ZM1.38852 9.28266L1.79272 9.11524L1.79272 9.11524L1.38852 9.28266ZM4.54376 11.0782L4.53622 11.5156L4.53622 11.5156L4.54376 11.0782ZM2.96701 10.8612L2.79959 11.2654L2.79959 11.2654L2.96701 10.8612ZM12.6112 9.28266L13.0154 9.45009L13.0154 9.45009L12.6112 9.28266ZM9.45589 11.0782L9.44836 10.6408L9.44836 10.6408L9.45589 11.0782ZM11.0327 10.8612L11.2001 11.2654L11.2001 11.2654L11.0327 10.8612ZM11.4405 1.5963L11.2119 1.96933L11.2119 1.96933L11.4405 1.5963ZM12.4034 2.55922L12.7764 2.33062L12.7764 2.33062L12.4034 2.55922ZM2.55922 1.5963L2.33062 1.22327L2.33062 1.22327L2.55922 1.5963ZM1.5963 2.55922L1.22327 2.33062L1.22327 2.33062L1.5963 2.55922ZM5.4848 11.2056L5.70476 10.8274L5.70476 10.8274L5.4848 11.2056ZM8.01021 12.6988L8.32643 12.1646L7.57345 11.7189L7.25723 12.2531L8.01021 12.6988ZM5.67322 12.1646L5.98944 12.6988L6.74242 12.2531L6.4262 11.7189L5.67322 12.1646ZM7.25723 12.2531C7.14479 12.4431 6.85487 12.4431 6.74242 12.2531L5.98944 12.6988C6.44069 13.4612 7.55896 13.4612 8.01021 12.6988L7.25723 12.2531ZM6.12484 1.604H7.87484V0.729004H6.12484V1.604ZM12.3957 6.12484V6.70817H13.2707V6.12484H12.3957ZM1.604 6.70817V6.12484H0.729004V6.70817H1.604ZM0.729004 6.70817C0.729004 7.38168 0.728767 7.90873 0.757771 8.33382C0.787043 8.76285 0.847554 9.1199 0.984325 9.45009L1.79272 9.11524C1.70747 8.90943 1.65697 8.65873 1.63074 8.27426C1.60424 7.88586 1.604 7.39366 1.604 6.70817H0.729004ZM4.5513 10.6408C3.81896 10.6281 3.43522 10.5815 3.13443 10.457L2.79959 11.2654C3.26915 11.4599 3.80397 11.503 4.53622 11.5156L4.5513 10.6408ZM0.984325 9.45009C1.32475 10.272 1.97772 10.9249 2.79959 11.2654L3.13444 10.457C2.52697 10.2053 2.04434 9.72271 1.79272 9.11524L0.984325 9.45009ZM12.3957 6.70817C12.3957 7.39366 12.3954 7.88586 12.3689 8.27426C12.3427 8.65873 12.2922 8.90943 12.207 9.11524L13.0154 9.45009C13.1521 9.1199 13.2126 8.76285 13.2419 8.33382C13.2709 7.90873 13.2707 7.38168 13.2707 6.70817H12.3957ZM9.46343 11.5156C10.1957 11.503 10.7305 11.4599 11.2001 11.2654L10.8652 10.457C10.5645 10.5815 10.1807 10.6281 9.44836 10.6408L9.46343 11.5156ZM12.207 9.11524C11.9553 9.72271 11.4727 10.2053 10.8652 10.457L11.2001 11.2654C12.022 10.9249 12.6749 10.272 13.0154 9.45009L12.207 9.11524ZM7.87484 1.604C8.83806 1.604 9.52975 1.60447 10.0693 1.65576C10.6023 1.70644 10.9415 1.80364 11.2119 1.96933L11.6691 1.22327C11.2381 0.959169 10.7492 0.841463 10.1521 0.784693C9.56155 0.728542 8.82112 0.729004 7.87484 0.729004V1.604ZM13.2707 6.12484C13.2707 5.17856 13.2711 4.43813 13.215 3.84757C13.1582 3.2505 13.0405 2.7616 12.7764 2.33062L12.0303 2.78781C12.196 3.0582 12.2932 3.39737 12.3439 3.93039C12.3952 4.46992 12.3957 5.16162 12.3957 6.12484H13.2707ZM11.2119 1.96933C11.5455 2.17375 11.8259 2.45422 12.0303 2.78781L12.7764 2.33062C12.4998 1.8793 12.1204 1.49984 11.6691 1.22327L11.2119 1.96933ZM6.12484 0.729004C5.17856 0.729004 4.43813 0.728542 3.84757 0.784693C3.2505 0.841463 2.7616 0.959169 2.33062 1.22327L2.78781 1.96933C3.0582 1.80364 3.39737 1.70644 3.93039 1.65576C4.46992 1.60447 5.16162 1.604 6.12484 1.604V0.729004ZM1.604 6.12484C1.604 5.16162 1.60447 4.46992 1.65576 3.93039C1.70644 3.39737 1.80364 3.0582 1.96933 2.78781L1.22327 2.33062C0.959169 2.7616 0.841463 3.2505 0.784693 3.84757C0.728542 4.43813 0.729004 5.17856 0.729004 6.12484H1.604ZM2.33062 1.22327C1.8793 1.49984 1.49984 1.8793 1.22327 2.33062L1.96933 2.78781C2.17376 2.45422 2.45422 2.17376 2.78781 1.96933L2.33062 1.22327ZM6.4262 11.7189C6.30776 11.5188 6.2038 11.3422 6.10271 11.2035C5.99623 11.0575 5.87409 10.9259 5.70476 10.8274L5.26484 11.5838C5.29249 11.5998 5.33017 11.6292 5.39559 11.7189C5.46638 11.816 5.54637 11.9503 5.67322 12.1646L6.4262 11.7189ZM4.53622 11.5156C4.79236 11.52 4.9546 11.5233 5.07827 11.537C5.19383 11.5498 5.23863 11.5685 5.26484 11.5838L5.70476 10.8274C5.53398 10.7281 5.35627 10.6874 5.17457 10.6673C5.00098 10.6481 4.79119 10.6449 4.5513 10.6408L4.53622 11.5156ZM8.32643 12.1646C8.45328 11.9503 8.53327 11.816 8.60407 11.7189C8.66948 11.6292 8.70716 11.5998 8.73481 11.5838L8.29489 10.8274C8.12556 10.9259 8.00342 11.0575 7.89695 11.2035C7.79585 11.3422 7.69189 11.5188 7.57345 11.7189L8.32643 12.1646ZM9.44836 10.6408C9.20846 10.6449 8.99867 10.6481 8.82508 10.6673C8.64338 10.6874 8.46567 10.7281 8.29489 10.8274L8.73481 11.5838C8.76102 11.5685 8.80582 11.5498 8.92138 11.537C9.04506 11.5233 9.20729 11.52 9.46343 11.5156L9.44836 10.6408Z' fill='${encodeURIComponent(theme.colors.error[750])}'/> <path id='Vector_2' d='M4.6665 5.25H9.33317' stroke='${encodeURIComponent(theme.colors.error[750])}' stroke-width='0.875' stroke-linecap='round'/> <path id='Vector_3' d='M4.6665 7.2915H7.87484' stroke='${encodeURIComponent(theme.colors.error[750])}' stroke-width='0.875' stroke-linecap='round'/> </g> </svg>")`;

const missingScriptIndicatorIcon = `url("data:image/svg+xml;utf8,<svg width='17' height='17' viewBox='0 0 17 17' fill='white' xmlns='http://www.w3.org/2000/svg'> <g id='Linear / Essentional, UI / Info Circle' clip-path='url(%23clip0_7171_1297)'> <circle id='Vector' cx='8.07048' cy='8.82682' r='6.66667' stroke='${encodeURIComponent(theme.colors.error[750])}'/> <path id='Vector_2' d='M8.07031 12.1602V8.16016' stroke='${encodeURIComponent(theme.colors.error[750])}' stroke-linecap='round'/> <circle id='Vector_3' cx='0.666667' cy='0.666667' r='0.666667' transform='matrix(1 0 0 -1 7.40381 6.82715)' fill='${encodeURIComponent(theme.colors.error[750])}'/> </g> <defs> <clipPath id='clip0_7171_1297'> <rect width='16' height='16' fill='white' transform='translate(0.0703125 0.827148)'/> </clipPath> </defs> </svg>")`;

export const TimelineStyleWrapper = styled.div<{
    timeIndicator: string;
    playLoading: boolean;
    thumbnails: string[];
    sceneAreDurationsCalculated: boolean[];
    sceneShouldIndicateMissingScripts: boolean[];
    sceneDurations: number[];
}>`
    > div:first-child {
        display: none;
    }

    .polotno-pages-timeline {
        height: 116px !important;
        padding-left: 19px !important;

        > div:first-child {
            height: 100% !important;

            // scenes container
            > div:first-child {
                align-items: center;

                > div:first-child {
                    align-items: center;

                    // empty space for play button
                    > div:first-child {
                        width: 84px !important;
                    }

                    // animation indicator
                    > div:nth-child(2) > div:nth-last-child(2) {
                        background-color: black !important;
                        z-index: 5;

                        :before {
                            position: absolute;
                            top: -12px;
                            left: -6px;
                            content: ${({ timeIndicator }) => `url(${timeIndicator})`};
                        }
                    }

                    // scene container
                    .polotno-pages-container {
                        // Last scene element, remove margin-right
                        > div:last-child {
                            > div:nth-child(1) {
                                margin-right: 0px !important;
                            }

                            > div:nth-child(2) {
                                margin-right: 0px !important;
                            }
                        }

                        ${({ thumbnails, sceneAreDurationsCalculated, sceneShouldIndicateMissingScripts, sceneDurations }) =>
                            `
                            ${thumbnails
                                .map(
                                    (thumbnail, index) => `
                                .polotno-page-container:nth-child(${index + 1}) {
                                    > div:nth-child(1) {
                                        z-index: 0;
                                        ${!!thumbnail ? `background-image: url(${thumbnail}) !important` : 'background-image: none !important'};
                                        ${
                                            sceneShouldIndicateMissingScripts[index] &&
                                            2 * sceneDurations[index] >= DEFAULT_SCENE_DURATION_IN_MS &&
                                            `
                                                :after {
                                                    z-index: 1;
                                                    content: ${missingScriptIndicatorIcon};
                                                    padding: 1px;
                                                    width: 16px;
                                                    height: 16px;                                                
                                                    position: absolute;
                                                    top: 4px !important;
                                                    left: 4px !important;
                                                    pointer-events: auto; /* Ensure :after can receive mouse events */
                                                }
                                                :hover:before {
                                                    position: fixed;
                                                    transform: translateY(-160%);
                                                    color: ${theme.colors.error[750]};
                                                    background-color: ${theme.colors.error[50]};
                                                    border-radius: 8px;
                                                    padding: 6px 9px 6px 8px;
                                                    content: ${missingScriptTooltipIcon} 'Missing script';
                                                    font-weight: 500;
                                                    box-sizing: content-box;
                                                }
                                            `
                                        }
                                    }
                                    ${
                                        sceneShouldIndicateMissingScripts[index] &&
                                        `
                                            > div:nth-child(2) {
                                                border-color: ${theme.colors.error[750]} !important;
                                            }
                                        `
                                    }
                                    ${
                                        !sceneAreDurationsCalculated[index] &&
                                        `
                                            > div:nth-child(3) {
                                                font-size: 0px !important;

                                                :before {
                                                    content: '${NO_DURATION_CONTENT}';
                                                    font-size: 10px !important;
                                                }                                                
                                            }
                                        `
                                    }
                                }
                            `
                                )
                                .join('')}
                        `}

                        // scene element
                        .polotno-page-container {
                            // scene thumbnail
                            > div:nth-child(1) {
                                border: 2px solid rgba(0, 0, 0, 0.1);
                                border-radius: 8px !important;
                                background-repeat: no-repeat !important;
                                background-position: center;
                                margin-right: 1px !important;
                                background-repeat: repeat-x !important;

                                // scene loader
                                > div {
                                    display: none;
                                }
                            }

                            // page frame
                            > div:nth-child(2) {
                                border-radius: 8px !important;
                                margin-right: 1px !important;
                            }

                            // active scene indicator
                            > div[style*='rgba(0, 161, 255, 0.9)'] {
                                border-color: black !important;
                                z-index: 5;
                            }

                            // resize button
                            > div:nth-last-child(2) {
                                display: none;
                            }

                            // scene time tag
                            > div:nth-child(3) {
                                border-radius: 4px !important;
                                background-color: rgba(34, 34, 34, 0.8) !important;
                                color: white !important;
                                font-size: 10px !important;
                                font-weight: 700;
                                padding: 0 2px !important;
                            }

                            .polotno-page-menu {
                                top: 6px;
                                right: 6px;

                                > span > button {
                                    width: 24px !important;
                                    height: 24px !important;
                                    min-width: unset;
                                    min-height: unset;
                                    border-radius: 6px !important;
                                    outline: none;
                                    background-color: ${theme.colors.black[700]};

                                    &.bp5-active {
                                        background-color: ${theme.colors.black[900]};
                                    }

                                    :hover {
                                        background-color: ${theme.colors.black[900]};
                                    }

                                    svg {
                                        width: 12px;
                                        height: 12px;
                                        fill: white;
                                    }
                                }
                            }
                        }
                    }

                    // add scene button
                    > button:nth-child(3) {
                        margin-left: 8px;
                        border-radius: 10px;
                        width: 60px !important;
                        height: 60px !important;
                        background-color: ${({ theme }) => theme.colors.black[100]};
                        box-shadow: none;

                        :hover {
                            background-color: ${({ theme }) => theme.colors.black[300]};
                        }

                        svg {
                            fill: #00000099;
                        }
                    }
                }
            }

            // play button container
            .polotno-play-button-container {
                top: 22px !important;
                width: 60px !important;
                display: flex;
                flex-direction: column;
                align-items: center;

                // play button
                .bp5-button {
                    width: 52px !important;
                    height: 52px !important;
                    outline: none;
                    border: ${({ sceneAreDurationsCalculated, theme }) =>
                        sceneAreDurationsCalculated.every(Boolean) ? 'none' : `2px dashed ${theme.colors.black[300]}`};

                    background-color: white;
                    box-shadow: ${({ theme, sceneAreDurationsCalculated }) =>
                        sceneAreDurationsCalculated.every(Boolean)
                            ? `
                        0.356px 0.948px 1.304px 0px rgba(187, 187, 187, 0.12),
                        1.304px 3.32px 4.624px -0.474px rgba(187, 187, 187, 0.17),
                        2.845px 7.232px 10.196px -0.948px rgba(187, 187, 187, 0.23),
                        6.284px 15.768px 22.289px -1.423px rgba(187, 187, 187, 0.29),
                        inset 0 0 0 1px ${theme.colors.black[300]},
                        0 1px 2px ${theme.colors.black[300]}
                    `
                            : `0.356px 0.948px 1.304px 0px rgba(187, 187, 187, 0.12),
                            1.304px 3.32px 4.624px -0.474px rgba(187, 187, 187, 0.17),
                            2.845px 7.232px 10.196px -0.948px rgba(187, 187, 187, 0.23),
                            6.284px 15.768px 22.289px -1.423px rgba(187, 187, 187, 0.29),
                            0 1px 2px ${theme.colors.black[300]}`};

                    &:hover {
                        background-color: ${({ theme }) => theme.colors.black[100]};
                    }

                    span {
                        ${({ playLoading }) =>
                            playLoading
                                ? `
                        cursor: not-allowed;
                        pointer-events: none;
                        background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2222%22%20height%3D%2222%22%20viewBox%3D%220%200%2022%2022%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M11%201C12.3132%201%2013.6136%201.25866%2014.8268%201.7612C16.0401%202.26375%2017.1425%203.00035%2018.0711%203.92893C18.9997%204.85752%2019.7363%205.95991%2020.2388%207.17317C20.7413%208.38642%2021%209.68678%2021%2011C21%2012.3132%2020.7413%2013.6136%2020.2388%2014.8268C19.7362%2016.0401%2018.9997%2017.1425%2018.0711%2018.0711C17.1425%2018.9997%2016.0401%2019.7363%2014.8268%2020.2388C13.6136%2020.7413%2012.3132%2021%2011%2021C9.68678%2021%208.38642%2020.7413%207.17316%2020.2388C5.95991%2019.7362%204.85752%2018.9997%203.92893%2018.0711C3.00034%2017.1425%202.26375%2016.0401%201.7612%2014.8268C1.25866%2013.6136%200.999999%2012.3132%201%2011C1%209.68678%201.25866%208.38642%201.76121%207.17316C2.26375%205.95991%203.00035%204.85751%203.92894%203.92893C4.85752%203.00034%205.95992%202.26375%207.17317%201.7612C8.38643%201.25866%209.68679%200.999999%2011%201L11%201Z%22%20stroke%3D%22%23F3F3F3%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3Cpath%20d%3D%22M11%201C12.3132%201%2013.6136%201.25866%2014.8268%201.7612C16.0401%202.26375%2017.1425%203.00035%2018.0711%203.92893C18.9997%204.85752%2019.7363%205.95991%2020.2388%207.17317C20.7413%208.38642%2021%209.68678%2021%2011%22%20stroke%3D%22%23FF882E%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3C/svg%3E");
                        background-size: cover;
                        animation: spin 1s linear infinite;
                        padding: 12px;
                        `
                                : 'cursor: pointer;'}
                    }

                    .bp5-icon-play {
                        ${({ playLoading }) =>
                            !playLoading &&
                            `
                                background-image: url(${PlayPreview});
                                background-size: cover;
                            `}

                        svg {
                            visibility: hidden;
                        }
                    }

                    svg {
                        ${({ playLoading }) => (playLoading ? 'display: none;' : 'display: block; fill: black')}
                    }
                }

                // timer
                div {
                    white-space: nowrap;
                }

                ${({ sceneAreDurationsCalculated }) =>
                    `
                        ${
                            !sceneAreDurationsCalculated.every(Boolean) &&
                            `
                            > div:nth-child(2) {
                                font-size: 0px !important;                       
                            }
                        `
                        }
                `}
            }
        }
        @keyframes spin {
            from {
                transform: rotate(0deg);
            }
            to {
                transform: rotate(360deg);
            }
        }
    }
`;
